module.exports = __webpack_public_path__ + "img/talegram_logo.11fdfde4.svg";